import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import { Stack, Typography, useMediaQuery } from '@mui/material';
import { TipsCard } from '../../organisms';
import Page from '../../organisms/Page';

const ErrorPage = ({ actions = null, picture, solution = null, subtitle, title }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Page title="Erreur" className="page" sx={{ alignItems: 'center' }}>
      <Stack sx={styleContainer}>
        {picture}

        <Stack sx={{ alignItems: 'center', textAlign: 'center' }}>
          <Typography variant="h3">{title}</Typography>
          <Typography color="text.disabled">{subtitle}</Typography>
        </Stack>

        {solution && <TipsCard tip={solution} />}

        {actions && <Stack sx={styleActionsWrapper(isMobile)}>{actions}</Stack>}
      </Stack>
    </Page>
  );
};

const styleContainer = {
  flexGrow: 1,
  alignItems: 'center',
  gap: 2,
  p: 4,
  maxWidth: '600px'
};

const styleActionsWrapper = (isMobile) => ({
  alignSelf: isMobile ? 'stretch' : null,
  flexGrow: isMobile ? 1 : 0,
  justifyContent: isMobile ? 'flex-end' : null
});

ErrorPage.propTypes = {
  actions: PropTypes.node,
  picture: PropTypes.node,
  solution: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string
};

export default ErrorPage;
